import { STATS } from '@/mocks/site';

export default function StatsBar() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-6">
          {STATS.map((item, index) => (
            <div
              key={item.label}
              className={`flex items-center gap-4 ${
                index !== STATS.length - 1 ? 'lg:border-r lg:border-background-200' : ''
              }`}
            >
              <span className="w-12 h-12 md:w-14 md:h-14 shrink-0 flex items-center justify-center rounded-md bg-primary-500/10 border border-primary-500/25 text-primary-500 text-xl md:text-2xl">
                <i className={item.icon}></i>
              </span>
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-2xl md:text-3xl text-foreground-950">
                    {item.value}
                  </span>
                  <span className="text-xs text-foreground-600">{item.unit}</span>
                </div>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}